var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDumbell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 29,
    viewBox: "0 0 56 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .primary {\n            fill: #767676;\n        }\n\n        .secondary {\n            fill: #767676;\n        }\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M45.4,1.7v25.6c0,0.7-0.6,1.2-1.2,1.2h-5c-0.7,0-1.2-0.5-1.2-1.2V1.7c0-0.7,0.6-1.2,1.2-1.2h5 C44.9,0.5,45.4,1,45.4,1.7z M16.8,0.5h-5c-0.7,0-1.2,0.5-1.2,1.2v25.6c0,0.7,0.6,1.2,1.2,1.2h5c0.7,0,1.2-0.5,1.2-1.2V1.7 C18,1,17.5,0.5,16.8,0.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    d: "M8.1,4.8H5.6C4.9,4.8,4.4,5.3,4.4,6v6.1H3c-1.7,0-3,1.1-3,2.4s1.4,2.4,3,2.4h1.3V23c0,0.7,0.6,1.2,1.2,1.2h2.5 c0.7,0,1.2-0.5,1.2-1.2v-6.1v-4.9V6C9.3,5.3,8.8,4.8,8.1,4.8z M19.3,16.9h17.4v-4.9H19.3V16.9z M53,12.1h-1.3V6 c0-0.7-0.6-1.2-1.2-1.2h-2.5c-0.7,0-1.2,0.5-1.2,1.2v6.1v4.9V23c0,0.7,0.6,1.2,1.2,1.2h2.5c0.7,0,1.2-0.5,1.2-1.2v-6.1H53 c1.7,0,3-1.1,3-2.4S54.6,12.1,53,12.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDumbell);
export default __webpack_public_path__ + "static/media/dumbell.e0b4cd8a40270c670c822c1b0970b007.svg";
export { ForwardRef as ReactComponent };